/* eslint-disable no-unused-vars */
import React from 'react';
// import { appInsights } from 'telemetry-service';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, redirectUrl: `${window.location?.origin}/error` };
  }

  static getDerivedStateFromError(error) {
    console.log(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log(error, errorInfo);
    // appInsights.trackException({ error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      if (process.env.NODE_ENV !== 'development') {
        window.location.href = this.state.redirectUrl;
        // window.location.reload();
      }
      return <></>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
